import React, { Children } from 'react'
import { Modal } from '@mui/material'
import deleteModalStyle from './DeleteConformation.module.css'

const DeleteConformation = ({open,onClose,onConfirm,onReject,children}) => {

    return (

        <Modal
            open={open}
            onClose={onClose}
        >
            <div className={deleteModalStyle.modalMainDiv}>
                <form onSubmit={(e) => {e.preventDefault(); onConfirm();}} style={{width:'100%'}}>

                    <div className={deleteModalStyle.deleteFormDiv}>
                        {/* <h2>Delete Modal</h2>
                        <p>Are you sure if you want delete item</p> */}
                        {children}

                        <div className={deleteModalStyle.deleteModalButtons}>

                            <button className={`${deleteModalStyle.modalDeleteBtn} ${deleteModalStyle.redButton}`}  >Delete</button>
                            <p onClick={onClose}>Cancel</p>

                        </div>

                    </div>
                </form>
            </div>

        </Modal>
    )
}

export default DeleteConformation
